// extracted by mini-css-extract-plugin
module.exports = {"container":"JobTitleTag_container__wmUDw","card":"JobTitleTag_card__3D0MU","image":"JobTitleTag_image__HbcwZ","sending":"JobTitleTag_sending__3nxPh"};